/****************************************************************************************************************
 * ©2018 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
 *
 * The EdgeVerve proprietary software program ('Program'), is protected by copyrights laws, international treaties and
 * other pending or existing intellectual property rights in India, the United States and other countries. The Program
 * may contain / reference third party or open source components, the rights to which continue to remain with the
 * applicable third party licensors or the open source community as the case may be and nothing here transfers the
 * rights to the third party and open source components, except as expressly permitted. Any unauthorized reproduction,
 * storage, transmission in any form or by any means (including without limitation to electronic, mechanical, printing,
 * photocopying, recording or otherwise), or any distribution of this Program, or any portion of it, may result in
 * severe civil and criminal penalties, and will be prosecuted to the maximum extent possible under the law.
 *****************************************************************************************************************/

import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TreeComponent } from '@ali-hm/angular-tree-component';
import { SupplierAction } from '../../models/SupplierAction';
import { SupplierHeaderData } from '../../models/SupplierHeader';
import { CommonService } from '../../services/common.service';
import { DataService } from '../../services/data.service';
import { HierarchyService } from '../../services/hierarchy.service';

import {CommonService as _commonService} from '../../../shared/services/common.service'

export class SupplierNode {
  children: SupplierNode[];
  name: string;
  nodeId: string;
  orgCode: string;
  orgType: string;
  isExpanded: boolean = true;
  id:String;
}

@Component({
    selector: 'app-supp-hierarchy',
    templateUrl: './supp-hierarchy.component.html',
    styleUrls: ['./supp-hierarchy.component.scss'],
    standalone: false
})
export class SuppHierarchyComponent implements OnInit, AfterViewInit {

  nodes: SupplierNode[];
  @ViewChild('tree') tree: TreeComponent;

  options = {};
  selectedNode: SupplierNode;

  user: any;
  isMapHierarchyBtn = false;
  isRemoveHierarchyBtnEnabled = false;
  supplierList: Array<any> = [];
  headerData: SupplierHeaderData;
  pageTitle = 'supplier.hierarchy.pageTitle';
  isAppBusy = true;
  squenceId = Number;
  userSelectedNodeId:any;

  constructor(
    private hierarchyService: HierarchyService,
    private commonService: CommonService,
    private dataService: DataService,
    private translate: TranslateService,
    private router: Router,
    public dialogRef: MatDialogRef<SuppHierarchyComponent>,
    private _common: _commonService
  ) { }

    async ngOnInit() {

    this.headerData = new SupplierHeaderData();
    this.translate.get(this.pageTitle).subscribe(result => this.headerData.title = result);

    // Creating Back Action
    const headerBackAction = new SupplierAction();
    headerBackAction.title = await this._common.translate("supplier.hierarchy.userList");
    headerBackAction.action = 'back';
    headerBackAction.color = 'primary';
    this.headerData.backAction = headerBackAction;

    // Getting the selected user
    this.user = this.dataService.suppuser;    
    this.nodes = this.dataService.defaultHierarchy;    
    this.isAppBusy = true;
    this.hierarchyService.getExistingUserHierarchy(this.user.userCode).subscribe(response => {
      if (response.length > 0) {
        this.supplierList = [];
        // this.squenceId = response[0][0];
        // const orgCodes = response[0][2].split('>');
        for (let i = 0 ; i < response.length ;  i++) {          
          let node = this.tree.treeModel.getNodeById(response[i].orgUnitsCode);        
          const nodeName = response[i].userField1 || node.data.name                  
          let mappings = {name: nodeName, id: response[i].orgUnitsCode};
          this.supplierList.push(mappings);
        }
      }
    });
    this.isAppBusy = false;
  }

   ngAfterViewInit() {
    if(this.nodes && this.nodes.length != 0)
      this.tree.treeModel.expandAll();
  }


  expandNode(nodeId: any) {
    this.userSelectedNodeId = nodeId;
    this.tree.treeModel.collapseAll();
    let node = this.tree.treeModel.getNodeById(nodeId); 
    this.supplierList.forEach(i => {
      if(i.id == nodeId){
        i.active = true;
      }else i.active = false; 
    });
    this.isRemoveHierarchyBtnEnabled = true;
    this.isMapHierarchyBtn = true;
    node.setActiveAndVisible(true);    
  }
    setUserHierarchy(node: any, selected: boolean) {   
        if(selected){
          this.selectedNode = node;
          this.isMapHierarchyBtn = true;
        }else {
          this.selectedNode = undefined;
          this.isMapHierarchyBtn = false;
        }
        
      // this.supplierList = [];
      // console.log(node);
      // const orgCodes = node.id.split('>');
      // for (let i = orgCodes.length - 1; i >= 0; i--) {
      //   const nodeName = this.getNodeName(orgCodes[i]);
      //   this.supplierList.push(nodeName);
      // }
  }

  getNodeName(id: any) {
    var trees = this.nodes;
    var nodeName = '';
    var treeCount = trees.length;
    for (var i = 0; i < treeCount; i++) {
      var orgCode = trees[i].orgCode;
      if (orgCode === id) {
        nodeName = trees[i].name;
        break;
      } else {
        nodeName = this.checkSubtree(trees[i].children, id);
      }
    }
    return nodeName;
  }

  async removeMappingToUser(){    
    let node = this.tree.treeModel.getNodeById(this.userSelectedNodeId);    
    let path = [];
    while(node.realParent) {
      node = node.realParent;     
      path.push(node.data.name)
    }    
    // this.isMapHierarchyBtn = false;
    let strPath = path.reverse().join('>');
     strPath = strPath ? `${strPath} > ${node.data.name}` : strPath;
     let selected = node.data;
    const data = {      
      'userCode': this.user.userCode,
      'orgUnitsCode':selected.orgCode ||selected.id,
      'orgUnitsType': selected.orgType,
      'userField1': strPath
    };  
    if(data.orgUnitsCode){
      this.hierarchyService.removeMapping(data).subscribe(async res=> {
        this.supplierList = this.supplierList.filter(i=> i.id != this.userSelectedNodeId);
        this.isRemoveHierarchyBtnEnabled = false;
        this.commonService.openSnackBar(await this._common.translate('supplier.hierarchy.removeMappingSuccess'));    
      }, error=> {
        this.commonService.openSnackBar(error.error.message);
      });
    } else {
      this.commonService.openSnackBar(await this._common.translate('supplier.hierarchy.removeMappingSelectError'));      
      
    }
    
  }

  checkSubtree(subTrees: SupplierNode[], id: any): any {
    const childCount = subTrees.length;
    let nodeName = '';
    for (let i = 0; i < childCount; i++) {
      const orgCode = subTrees[i].orgCode;
      if (orgCode === id) {
        nodeName = subTrees[i].name;
        break;
      } else {
        nodeName = this.checkSubtree(subTrees[i].children, id);
      }
    }
    return nodeName;
  }

  async mapUserToHierarchy() {    
    let node = this.tree.treeModel.getNodeById(this.selectedNode.id);      
    let path = [];
    while(node.realParent) {
      node = node.realParent;     
      path.push(node.data.name)
    }    
    this.isMapHierarchyBtn = false;
    let strPath = path.reverse().join('>');
     strPath = strPath ? `${strPath}>${node.data.name}` : strPath;
    const data = {
      'seqId': this.squenceId,
      'userCode': this.user.userCode,
      'orgUnitsCode': this.selectedNode.orgCode || this.selectedNode.id,
      'orgUnitsType': this.selectedNode.orgType,
      'userField1': strPath
    };
    let alreadyExists = this.supplierList.filter(i=>i.id === data.orgUnitsCode);
    if(alreadyExists.length == 0){
      this.hierarchyService.setData(data).toPromise().catch(error => {
        this.commonService.openSnackBar(error.message);
      }).then(async response => {
        if (response && response.errorMessage) {
          this.commonService.openSnackBar(response.errorMessage);
        } else if (!response) {
          this.commonService.openSnackBar(await this._common.translate('supplier.hierarchy.mappingError'));
        } else {
          this.commonService.openSnackBar(await this._common.translate('supplier.hierarchy.mappingSuccess'));
          // this.dialogRef.close();
          let node = this.tree.treeModel.getNodeById(response.orgUnitsCode);        
            const nodeName = response.userField1 || node.data.name                  
            let mappings = {name: nodeName, id: response.orgUnitsCode};
            this.supplierList.push(mappings);
        }
        this.isMapHierarchyBtn = true;
      });
    } else{
      this.commonService.openSnackBar(await this._common.translate('supplier.hierarchy.mappingDuplicateError'));
    }
  }

  closeModal(): void {
    this.dialogRef.close();
  }
};

